"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TicketingRecurrenceType = void 0;
var TicketingRecurrenceType;
(function (TicketingRecurrenceType) {
    TicketingRecurrenceType["Once"] = "Once";
    TicketingRecurrenceType["WeekDays"] = "WeekDays";
    TicketingRecurrenceType["Daily"] = "Daily";
    TicketingRecurrenceType["Weekly"] = "Weekly";
    TicketingRecurrenceType["Monthly"] = "Monthly";
})(TicketingRecurrenceType || (exports.TicketingRecurrenceType = TicketingRecurrenceType = {}));
